(function () {
    var map;
    var selectedShape = null;
    var lastSelectedShape = null;
    var selectedArea = [];
    var markers = [];
    var imageDim = {height: 640, width: 640};
    var drawingManager;
    var GOOGLE_MAPS_KEY = 'AIzaSyDYb9Bc-pOz1h61georfV3hu9c4K8iXEdA';

    /**
     * Init the map, create the drawing manager and add it to the map,
     * then initialize the events "marker complete" and "overlay complete" for
     * the drawing actions.
     */
    var init = function () {
        map = new google.maps.Map(document.getElementById('map'), {
            center: getCenter(),
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            rotateControl: false
        });

        map.setTilt(0);

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['polygon']
            },
            polygonOptions: {
                fillOpacity: 0,
                strokeWeight: 5,
                strokeColor: '#0EA2C8',
                zIndex: 1,
                editable: false
            }
        });


        drawingManager.setMap(map);

        var removePolygonButton = document.createElement('div');

        addCustomControl(removePolygonButton, 'polygon');

        removePolygonButton.index = 1;

        map.controls[google.maps.ControlPosition.TOP_CENTER].push(removePolygonButton);

        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        google.maps.event.addListener(drawingManager, 'overlaycomplete', savePolygon);

        if (!google.maps.Polygon.prototype.getBounds) {
            google.maps.Polygon.prototype.getBounds = function () {
                var bounds = new google.maps.LatLngBounds();
                this.getPath().forEach(function (element, index) {
                    bounds.extend(element);
                });
                return bounds;
            };
        }

        addTooltips();
    };

    var addTooltips = function() {
        setTimeout(function(){
            $(".gmnoprint").each(function(){
                addTooltip($(this), 'Stop drawing', 'Click here to stop the drawing');
                addTooltip($(this), 'Add a marker', 'Click here to add a marker to your map');
                addTooltip($(this), 'Draw a shape', 'Click here to draw a shape in your map');
            });

            $('.mapTooltip').tooltip();
        }, 2000);
    };

    var addTooltip = function(obj, key, title) {
        var polygon = obj.find("[title='" + key + "']");
        polygon.attr('data-tooltip', title);
        polygon.attr('data-position', 'bottom');
        polygon.addClass('mapTooltip');
    };

    /**
     * Return map center based on property or country if property has not center.
     * @returns {{lat: number, lng: number}}
     */
    var getCenter = function() {
        var lat = $("input[name='listing[latitude]']").val();
        var long = $("input[name='listing[longitude]']").val();

        var center = {};
        if(lat.length > 0 && long.length > 0) {
            center = {
                lat: parseFloat(lat),
                lng: parseFloat(long)
            };
        }

        return center.lat && center.lng ? center : Utils.getUSACenter();
    };

    /**
     * Load the property's already selected shape and pin if any.
     */
    var loadProperty = function () {
        $.ajax({
            type: "GET",
            url: $("body").data("base-url") + "properties/get",
            data: {'id': $('input[name="listing[id]"]').val()},
            success: function (responseText) {
                var response = JSON.parse(responseText);

                if (response.map_selected_area && response.map_selected_area.length > 0) {
                    //Draw selected property area in the map
                    var coords = JSON.parse(response.map_selected_area);

                    for (var j = 0; j < coords.length; j++) {
                        coords[j].lat = parseFloat(coords[j].lat);
                        coords[j].lng = parseFloat(coords[j].lng);
                    }

                    var area = new google.maps.Polygon({
                        paths: coords,
                        fillOpacity: 0,
                        strokeWeight: 5,
                        strokeColor: '#0EA2C8',
                        zIndex: 1,
                        editable: false
                    });

                    area.setMap(map);

                    setArea(area);
                    //Set property map zoom
                    if (response.map_zoom) {
                        map.setZoom(parseInt(response.map_zoom));
                    }
                } else if(response.latitude && response.longitude) {
                    //If no selected area, then use lat and long
                    map.setCenter(new google.maps.LatLng(response.latitude, response.longitude));
                    map.setZoom(20);
                }
            },
            failure: function (errMsg) {
                Materialize.toast("It was not possible to execute that action.", 2000);
            }
        }).done(function(res){
            var data = JSON.parse(res);

            if (data.map_zoom) {
                map.setZoom(parseInt(data.map_zoom));
            }
        });
    };

    /**
     * Add a marker to the map from a click event.
     * @param marker
     */
    function addMarker(marker) {
        var latPinEl = $("input[name='listing[map_pin_lat]']");
        var lngPinEl = $("input[name='listing[map_pin_lng]']");
        var latitude = $("input[name='listing[latitude]']");
        var longitude = $("input[name='listing[longitude]']");

        latPinEl.val(marker.getPosition().lat());
        lngPinEl.val(marker.getPosition().lng());
        latitude.val(marker.getPosition().lat());
        longitude.val(marker.getPosition().lng());

        clearMarkers();

        markers.push(marker);
    }

    /**
     * Save the polygon area in the map to a variable.
     * @param event
     */
    function savePolygon(event) {
        if (event.type && event.type === google.maps.drawing.OverlayType.POLYGON) {
            clearSelection();
            selectedShape = event.overlay;
        }
    }

    function addCustomControl(controlDiv, type) {
        if(type === 'polygon') {
            addSpecificCustomControl(controlDiv, 'Clear selected area from the map', '<i class="small material-icons" style="font-size: 20px !important;">clear</i>', clearSelection);
        } else if(type === 'marker') {
            addSpecificCustomControl(controlDiv, 'Clear pin from the map', '<i class="small material-icons" style="font-size: 20px !important;">clear</i>', clearMarkers);
        }
    }

    var addSpecificCustomControl = function(controlDiv,tooltip, icon, callback) {
        var ui = document.createElement('div');
        ui.style.backgroundColor = '#fff';
        ui.style.border = '2px solid #fff';
        ui.style.borderRadius = '2px 2px 2px 2px';
        ui.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        ui.style.cursor = 'pointer';
        ui.style.marginBottom = '22px';
        ui.style.marginTop = '5px';
        ui.style.marginLeft = '5px';
        ui.style.textAlign = 'center';
        ui.style.height = '23px';
        ui.style.width = '23px';
        ui.classList.add("mapTooltip");
        ui.setAttribute("data-position", "bottom");
        ui.setAttribute("data-tooltip", tooltip);
        controlDiv.appendChild(ui);

        var button = document.createElement('div');
        button.style.color = 'rgb(25,25,25)';
        button.style.fontFamily = 'Roboto,Arial,sans-serif';
        button.style.fontSize = '16px';
        button.style.lineHeight = '38px';
        button.innerHTML = icon;
        ui.appendChild(button);

        button.addEventListener('click', function () {
            callback();
        });
    };

    /**
     * Clear the polygon area and any marker in the map.
     */
    function clearSelection() {
        if (selectedShape) {
            selectedShape.setEditable(false);
            selectedShape.setMap(null);
            lastSelectedShape = selectedShape;
            selectedShape = null;
        }
    }

    /**
     * Remove all markers from map.
     */
    function clearMarkers() {
        setMapOnAll(null);
        markers = [];
    }

    /**
     * Set markers map as null.
     * @param map
     */
    function setMapOnAll(map) {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    }

    /**
     * Create the neeeded images for the kind of shape being drawn in the map.
     */
    function createMapImage() {
        if (selectedShape !== null && selectedShape !== undefined) {
            // Switch back to non-drawing mode after drawing a shape.
            drawingManager.setDrawingMode(null);

            var path = selectedShape.getPath();
            // Add the first point as the last point, so all the markers are connected
            selectedShape.getPath().push(selectedShape.getPath().getAt(0));

            selectedShape.getPath().forEach(function (element, index) {
                selectedArea.push({lat: element.lat(), lng: element.lng()});
            });

            var encodeString = google.maps.geometry.encoding.encodePath(path);

            var lat = selectedShape.getBounds().getCenter().lat();
            var lng = selectedShape.getBounds().getCenter().lng();

            getImage(GOOGLE_MAPS_KEY, encodeString, lat, lng);

            setArea(selectedShape);
        } else {
            if(markers.length > 0) {
                var pinLat = null;
                var pinLng = null;

                if(markers.hasOwnProperty(0)) {
                    pinLat = markers[0].getPosition().lat();
                    pinLng = markers[0].getPosition().lng();
                }

                getImage(GOOGLE_MAPS_KEY, null, pinLat, pinLng);
            } else {
                persist();
            }
        }
    }

    /**
     * Get a zoom level based on the map bounds.
     * @param bounds
     * @returns {number}
     */
    function getBoundsZoomLevel(bounds) {
        var WORLD_DIM = {height: 256, width: 256};

        var ZOOM_MAX = 21;

        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();

        var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

        var lngDiff = ne.lng() - sw.lng();
        var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        var latZoom = zoom(imageDim.height, WORLD_DIM.height, latFraction);
        var lngZoom = zoom(imageDim.width, WORLD_DIM.width, lngFraction);

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    /**
     * Create a polygon area in the map.
     * @param shape
     */
    function setArea(shape) {
        selectedShape = shape;
        shape.setEditable(false);
    }

    /**
     * Create a marker in the map.
     * @param latitude
     * @param longitude
     */
    function setPin(latitude, longitude) {
        var myLatLng = {lat: latitude, lng: longitude};
        var marker = new google.maps.Marker({
            position: myLatLng,
            map: map
        });

        markers.push(marker);
    }

    /**
     * Assemble a Google Static maps URL with the property data in it,
     * then send the data to the controller.
     * @param GOOGLE_MAPS_KEY
     * @param encodeString
     * @param lat
     * @param lng
     */
    function getImage(GOOGLE_MAPS_KEY, encodeString, lat, lng) {
        addTextToLoading('loadingtext', 1);
        var pinLat = null;
        var pinLng = null;

        if(markers.hasOwnProperty(0)) {
            pinLat = markers[0].getPosition().lat();
            pinLng = markers[0].getPosition().lng();
        }

        var zoomBounds = map.getZoom()? map.getZoom() : getBoundsZoomLevel(selectedShape.getBounds());
        var enc = encodeString;
        var size = imageDim.width + "x" + imageDim.height;
        var zoom = zoomBounds ? zoomBounds : 16;
        var center = lat + "," + lng;
        var path = "color:0x0EA2C8ff|weight:6|";
        var type = 'satellite';
        var icon = $('body').attr('data-base-url') + 'assets/img/marker.png';
        var imageUrl = "https://maps.googleapis.com/maps/api/staticmap?size=" + size +
            "&zoom=" + zoom +
            "&center=" + center +
            "&scale=" + 2 +
            (pinLat && pinLng? "&markers=icon:" + icon + "|" + pinLat + "," + pinLng: '') +
            "&maptype=" + type +
            "&path=" + path +
            (encodeString? "enc:" + enc : '' ) +
            "&key=" + GOOGLE_MAPS_KEY;

        addTextToLoading('loadingtext', 2);

        persist(imageUrl, zoom, lat, lng);
    }

    /**
     * Return a Google Static maps URL with the property pin in it.
     * @param GOOGLE_MAPS_KEY
     * @param lat
     * @param lng
     * @param pinLat
     * @param pinLng
     * @returns {string}
     */
    function getImageWithPin(GOOGLE_MAPS_KEY, lat, lng, pinLat, pinLng) {
        var size = 600 + "x" + 300;
        var zoom = 16;

        if(pinLat && pinLng) {
            lat = pinLat;
            lng = pinLng;
        }

        var center = lat + "," + lng;
        var type = 'roadmap';
        var icon = $('body').attr('data-base-url') + 'assets/img/marker_20180816.png';

        return "https://maps.googleapis.com/maps/api/staticmap?size=" + size +
            "&zoom=" + zoom +
            "&center=" + center +
            "&scale=" + 2 +
            "&maptype=" + type +
            "&markers=icon:" + icon + "|" + center +
            "&key=" + GOOGLE_MAPS_KEY;
    }

    /**
     * Return the data to be persisted in the database based on what the user
     * selected on the map.
     * @param imageUrl
     * @param zoom
     * @param lat
     * @param lng
     */
    function persist(imageUrl, zoom, lat, lng) {
        var pinLat = null;
        var pinLng = null;

        if(markers.hasOwnProperty(0)) {
            pinLat = markers[0].getPosition().lat();
            pinLng = markers[0].getPosition().lng();
        }

        var data = {
            step: $('#property-form').attr('data-step'),
            listing: {
                id: $('input[name="listing[id]"]').val(),
                account_id: $('input[name="listing[account_id]"]').val(),
                user_id: $('input[name="listing[user_id]"]').val(),
                property_boundaries: {}
            }
        };

        if ((imageUrl && zoom && lat && lng) || (pinLat && pinLng)) {
            //Save image
            if(imageUrl) {
                data.listing.map_image_url = imageUrl;
            }

            //Save lat and lng
            if (lat && lng) {
                data.listing.latitude = lat;
                data.listing.longitude = lng;
                data.listing.map_selected_area = selectedArea;
            }

            //Save zoom
            if(zoom) {
                data.listing.map_zoom = zoom;
            }

            //Save pin and override lat and long if pin was dropped
            if (pinLat && pinLng) {
                data.listing.latitude = pinLat;
                data.listing.longitude = pinLng;
                data.listing.map_pin = {};
                data.listing.map_pin.latitude = pinLat;
                data.listing.map_pin.longitude = pinLng;
            }

        } else {
            data.listing.map_pin = null;
        }

        save(data);
    }

    /**
     * Send the changes the the properties controller, so the map can be saved.
     * @param data
     */
    function save(data) {
        startLoading('#map-wrapper');
        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + "properties/save",
            data: data,
            success: function (responseText) {
                addTextToLoading('loadingtext', 3);
                stopLoading('#map-wrapper');

                var response = JSON.parse(responseText);

                var form = $('.property-boundaries-form');

                if (response.status === 'success') {
                    saveToast();
                    window.location.href = PropertiesController.createURI(form.attr('data-next'), response.id);
                } else {
                    Materialize.toast(response.message);
                }
            },
            failure: function (errMsg) {
                Materialize.toast("It was not possible to execute that action.", 2000);

                stopLoading('#map-wrapper');
            }
        });
    }

    $(document).on('click', '.properties-next-map', function () {
        createMapImage();
    });

    var initPin = function() {
        map = new google.maps.Map(document.getElementById('map-pin'), {
            center: getCenter(),
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            rotateControl: false
        });

        map.setTilt(0);

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['marker']
            }
        });

        drawingManager.setMap(map);

        var removeMarkerButton = document.createElement('div');

        addCustomControl(removeMarkerButton, 'marker');

        removeMarkerButton.index = 1;

        map.controls[google.maps.ControlPosition.TOP_CENTER].push(removeMarkerButton);

        google.maps.event.addListener(drawingManager, 'markercomplete', addMarker);

        google.maps.event.addListener(map, 'zoom_changed', setSelectedPinZoom);

        addTooltips();
    };

    var setSelectedPinZoom = function() {
        $("input[name='listing[map_pin_zoom]']").val(map.getZoom());
    };

    var setSelectedPin = function() {
        var latPinEl = $("input[name='listing[map_pin_lat]']");
        var lngPinEl = $("input[name='listing[map_pin_lng]']");

        var latitude = $("input[name='listing[latitude]']").val();
        var longitude = $("input[name='listing[longitude]']").val();

        var pinLatitude = latPinEl.val();
        var pinLongitude = lngPinEl.val();

        if (pinLatitude.length && pinLongitude.length) {
            latitude = pinLatitude;
            longitude = pinLongitude;
        }

        if(latitude.length && longitude.length) {
            latPinEl.val(latitude);
            lngPinEl.val(longitude);

            clearMarkers();

            setPin(parseFloat(latitude), parseFloat(longitude));

            if (markers.hasOwnProperty(0)) {
                var zoomEl = $("input[name='listing[map_pin_zoom]']");
                var zoom = zoomEl.val();

                if(zoom.length) {
                    map.setZoom(parseInt(zoom));
                    map.panTo(markers[0].position);
                } else {

                    if($("#route").val().length) {
                        zoomEl.val(16);
                        map.setZoom(16);
                        map.panTo(markers[0].position);
                    } else {
                        zoomEl.val(4);
                        map.setZoom(4);
                    }

                }
            }
        }
    };

    if (window.MapController === undefined) {
        window.MapController = {};
    }

    if (MapController.Properties === undefined) {
        MapController.Properties = {};
    }

    if (MapController.PropertiesPin === undefined) {
        MapController.PropertiesPin = {};
    }

    MapController.Properties.init = init;
    MapController.Properties.setSelectedArea = loadProperty;

    MapController.PropertiesPin.init = initPin;
    MapController.PropertiesPin.setSelectedPin = setSelectedPin;

})();